import request from '@/utils/http'
import { PFX, SRM_FILE_PRE } from '../constant/constant.js'
// ----------------应标查询-----------------------
// 应标查询获取列表
export const bidList = params => {
    return request({
        url: `${PFX}/bid/bidBidList`,
        method: 'post',
        data: params,
    })
}
// 应标文件
export const bidDocument = params => {
    return request({
        url: `${PFX}/bid/bidManageModuleFiles`,
        method: 'post',
        data: params,
    })
}
// 报名审核
export const signUpToE = params => {
    return request({
        url: `${PFX}/bid/updateApplyReview`,
        method: 'post',
        data: params,
    })
}
// 查询供应商是否合格
export const isQualified = params => {
    return request({
        url: `${PFX}/supplier/querySupplierStatusIsQualified`,
        method: 'get',
        params: params,
    })
}
// 查询供应商校验会计主体是否合格
export const isExamine = params => {
    return request({
        url: `${PFX}/supplier/chackSupplierInfoIsAccountingInfo`,
        method: 'get',
        params: params,
    })
}
// 查询有多少个供应商状态等
export const supplierType = params => {
    return request({
        url: `${PFX}/bid/bidSupplier/bidSupplierPushInfo`,
        method: 'post',
        data: params,
    })
}
// 上传应标文件
export const uploadBid = params => {
    return request({
        url: `${PFX}/bid/bidModuleFile/bidFileProcessing`,
        method: 'post',
        data: params,
    })
}
// 报名驳回
export const singReject = params => {
    return request({
        url: `${PFX}/bid/updateSignUpReject`,
        method: 'post',
        data: params,
    })
}
// ----------------费用查询-----------------------
// 费用查询获取列表
export const costList = params => {
    return request({
        url: `${PFX}/bid/bidSupplierCostList`,
        method: 'post',
        data: params,
    })
}
// 罚扣款
export const fineMoneyReq = params => {
    return request({
        url: `${PFX}/bid/costPenaltyDeductions`,
        method: 'post',
        data: params,
    })
}
// 审核确认
export const approval = params => {
    return request({
        url: `${PFX}/bid/costAssuranceAudit`,
        method: 'post',
        data: params,
    })
}
// 驳回
export const reject = params => {
    return request({
        url: `${PFX}/bid/costTurnDown`,
        method: 'post',
        data: params,
    })
}
// 退款列表查询
export const refund = params => {
    return request({
        url: `${PFX}/bid/bidSupplierCost/selectHasRefundList`,
        method: 'post',
        data: params,
    })
}
// 美的付查询刷新
export const PayByOrderNo = params => {
    return request({
        url: `${PFX}/bid/bidSupplierCosts/queryBidMideaPayByOrderNo`,
        method: 'post',
        data: params,
    })
}
// 同流对流表格数据
export const getLineDivisionList = params => {
    return request({
        url: `${PFX}/bid/getLineDivisionList`,
        method: 'post',
        data: params,
    })
}
// 同流对流表格数据
export const updateRecord = data => {
    return request({
        url: `${PFX}/bid/updateBidLineDivisionRecord/${data.id}`,
        method: 'put',
        data,
    })
}
// 同流对流-邮箱推荐
export const recommendSendEmail = params => {
    return request({
        url: `${PFX}/bid/recommendSendEmail`,
        method: 'post',
        data: params,
    })
}
// 同流对流-短信推荐
export const recommendSendMessage = params => {
    return request({
        url: `${PFX}/bid/recommendSendMessage`,
        method: 'post',
        data: params,
    })
}
// 同流对流-导出
export const exportLineDivision = data => {
    return request({
        // /api-srm-file/bid/supplierLineDivision/export/
        url: `${SRM_FILE_PRE}/bid/supplierLineDivision/export`,
        method: 'post',
        data,
    })
}
